import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "infographics-container" }
const _hoisted_3 = { class: "infographics-header-block text-center" }
const _hoisted_4 = { class: "infographics-logo" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h1", null, "CONVORALLY", -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "step-tab" }
const _hoisted_8 = { class: "step-content" }
const _hoisted_9 = { class: "box-container scrollable" }
const _hoisted_10 = { class: "dashboard-heading text-center" }
const _hoisted_11 = { class: "uppercase-text" }
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { class: "projects-heading text-center" }
const _hoisted_14 = { class: "uppercase-text" }
const _hoisted_15 = { class: "projects-division" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "project-wrap text-center" }
const _hoisted_19 = { class: "project-first" }
const _hoisted_20 = { class: "element-wrap" }
const _hoisted_21 = { class: "element-highlight uppercase-text" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = { class: "project-desc" }
const _hoisted_25 = { class: "element-wrap" }
const _hoisted_26 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = { class: "project-desc" }
const _hoisted_29 = { class: "element-wrap" }
const _hoisted_30 = { class: "element-highlight" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode()
const _hoisted_32 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_34 = { class: "project-desc" }
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "project-activity text-center" }
const _hoisted_38 = { class: "box-container" }
const _hoisted_39 = { class: "project-templates" }
const _hoisted_40 = { class: "element-wrap" }
const _hoisted_41 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode()
const _hoisted_43 = { class: "element-highlight" }
const _hoisted_44 = { class: "box-questionaire" }
const _hoisted_45 = { class: "element-wrap project-element" }
const _hoisted_46 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_47 = { class: "box-project" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "element-wrap" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "timg/chart.png",
    alt: ""
  })
], -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "bold-text" }
const _hoisted_53 = { class: "uppercase-text" }
const _hoisted_54 = { class: "message-boy" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-6 align-self-center" }
const _hoisted_57 = { class: "element-highlight" }
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("div", { class: "message" }, [
    /*#__PURE__*/_createVNode("img", {
      src: "timg/message-boy.png",
      alt: ""
    })
  ])
], -1)
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-5 align-self-center" }
const _hoisted_62 = { class: "add-text" }
const _hoisted_63 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createStaticVNode("<div class=\"col-2 col-lg-3  align-self-center\"><div class=\"plus\"><p>+</p></div></div><div class=\"col-5 col-lg-4\"><div class=\"members\"><img src=\"timg/client.png\" alt=\"\"></div></div>", 2)
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-5  align-self-center" }
const _hoisted_69 = { class: "add-text" }
const _hoisted_70 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<div class=\"col-2 col-lg-3 align-self-center\"><div class=\"plus\"><p>+</p></div></div><div class=\"col-5 col-lg-4\"><div class=\"channel\"><img src=\"timg/chat.png\" alt=\"\"></div></div>", 2)
const _hoisted_74 = { class: "dashboard-conclusion" }
const _hoisted_75 = { class: "create-step" }
const _hoisted_76 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_77 = /*#__PURE__*/_createStaticVNode("<div class=\"step-img\"><div class=\"chat\"><img src=\"timg/chat.png\" alt=\"\"></div><div class=\"plus align-self-center \"><p>+</p></div><div class=\"client\"><img src=\"timg/client.png\" alt=\"\"></div></div>", 1)
const _hoisted_78 = { class: "create-step" }
const _hoisted_79 = /*#__PURE__*/_createStaticVNode("<div class=\"step-img\"><div class=\"send-tutorial\"><img src=\"timg/send.png\" alt=\"\"></div><div class=\"plus align-self-center\"><p>+</p></div><div class=\"clip\"><img src=\"timg/clip-pin.png\" alt=\"\"></div><div class=\"plus align-self-center\"><p>+</p></div><div class=\"envelope-notification\"><img src=\"timg/envelope-notification.png\" alt=\"\"></div></div>", 1)
const _hoisted_80 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_81 = { class: "create-step" }
const _hoisted_82 = { class: "invite-member" }
const _hoisted_83 = { class: "invite" }
const _hoisted_84 = /*#__PURE__*/_createVNode("img", {
  src: "timg/new-account.png",
  alt: ""
}, null, -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("div", { class: "plus align-self-center" }, [
  /*#__PURE__*/_createVNode("p", null, "+")
], -1)
const _hoisted_86 = { class: "client" }
const _hoisted_87 = /*#__PURE__*/_createVNode("img", {
  src: "timg/client.png",
  alt: ""
}, null, -1)
const _hoisted_88 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_89 = { class: "or align-self-center" }
const _hoisted_90 = { class: "lowercase-text" }
const _hoisted_91 = { class: "envelope" }
const _hoisted_92 = /*#__PURE__*/_createVNode("img", {
  src: "timg/envelope.png",
  alt: ""
}, null, -1)
const _hoisted_93 = { class: "dashboard-end" }
const _hoisted_94 = { class: "dashboard-note" }
const _hoisted_95 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("img", {
  src: "timg/chat.png",
  alt: ""
}, null, -1)
const _hoisted_97 = /*#__PURE__*/_createVNode("p", null, " x5", -1)
const _hoisted_98 = { class: "step-move" }
const _hoisted_99 = { class: "step-prev" }
const _hoisted_100 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" }, null, -1)
const _hoisted_101 = { class: "step-next" }
const _hoisted_102 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-right" }, null, -1)
const _hoisted_103 = { class: "final-container" }
const _hoisted_104 = { class: "final-block" }
const _hoisted_105 = { class: "container" }
const _hoisted_106 = { class: "final-wrap" }
const _hoisted_107 = { class: "convorally-moto" }
const _hoisted_108 = { class: "italic" }
const _hoisted_109 = { class: "final-img-wrap" }
const _hoisted_110 = /*#__PURE__*/_createVNode("p", null, "www. ", -1)
const _hoisted_111 = /*#__PURE__*/_createVNode("p", null, ".com", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_P = _resolveComponent("P")
  const _component_TutorialStep = _resolveComponent("TutorialStep")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("section", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convoicon-blue.png`: 'timg/convoicon-blue.png' ,
            alt: ""
          }, null, 8, ["src"])
        ]),
        _hoisted_5,
        _createVNode("h2", null, _toDisplayString(_ctx.$t('project_manager_app')), 1),
        _createVNode(_component_P, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('project_manager_description')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_TutorialStep)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/dashboard-clock.png`: 'timg/dashboard-clock.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('dashboard')), 1),
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('access_existing_projects_create')) + " ", 1),
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('new_projects_and_review_activity_feed')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("h4", _hoisted_14, _toDisplayString(_ctx.$t('my_projects')), 1)
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, [
                        _createVNode("img", {
                          src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/folder.png`: 'timg/folder.png' ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('tap_on')), 1),
                        _createVNode("span", _hoisted_21, " +" + _toDisplayString(_ctx.$t('create_project')), 1),
                        _hoisted_22,
                        _hoisted_23,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('to_start_new_project')), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_24, [
                      _createVNode("div", _hoisted_25, [
                        _createVNode("img", {
                          src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/project.png`: 'timg/project.png' ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('tap_on_project_name_to_access')) + " ", 1),
                        _hoisted_26,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('detail_including_project_history')) + " ", 1),
                        _hoisted_27,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('channel_members_and_latest_forms')), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _createVNode("img", {
                          src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/chat.png`: 'timg/chat.png' ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('tap_on')) + " ", 1),
                        _createVNode("span", _hoisted_30, " “" + _toDisplayString(_ctx.$t('create_chat_channel')) + "”", 1),
                        _hoisted_31,
                        _hoisted_32,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('to_start_communicating')) + " ", 1),
                        _hoisted_33,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('with_your_project_members')) + ".", 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_34, [
                      _createVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('enter_preferred_channel')) + " ", 1),
                        _hoisted_35,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('name_and_description')) + ".", 1)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_36, [
                  _createVNode("div", _hoisted_37, [
                    _createVNode("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _createVNode("div", _hoisted_40, [
                          _createVNode("img", {
                            src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/board.png`: 'timg/board.png' ,
                            alt: ""
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('use_a_template_from')) + " ", 1),
                          _hoisted_41,
                          _hoisted_42,
                          _createVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('template_library')), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_44, [
                        _createVNode("div", _hoisted_45, [
                          _createVNode("img", {
                            src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/clipboard-multiple.png`: 'timg/clipboard-multiple.png' ,
                            alt: ""
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('create_custom')) + " ", 1),
                          _hoisted_46,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('questionnaire')), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_47, [
                        _createVNode("h4", null, _toDisplayString(_ctx.$t('activity_feed')), 1),
                        _hoisted_48,
                        _createVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('access_activity_history')) + " ", 1),
                          _hoisted_49,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('date_and_time')), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_50, [
                _createVNode("div", _hoisted_51, [
                  _createVNode("div", _hoisted_52, [
                    _createVNode("p", _hoisted_53, "#" + _toDisplayString(_ctx.$t('channel_name')), 1)
                  ]),
                  _createVNode("div", _hoisted_54, [
                    _createVNode("div", _hoisted_55, [
                      _createVNode("div", _hoisted_56, [
                        _createVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('tap_on')) + " ", 1),
                          _createVNode("span", _hoisted_57, "#" + _toDisplayString(_ctx.$t('channel')), 1),
                          _createTextVNode(_toDisplayString(_ctx.$t('name_to_start_chatting')), 1)
                        ])
                      ]),
                      _hoisted_58
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_59, [
                  _createVNode("div", _hoisted_60, [
                    _createVNode("div", _hoisted_61, [
                      _createVNode("div", _hoisted_62, [
                        _createVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('add_as_many')) + " ", 1),
                          _hoisted_63,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('members_to_your')) + " ", 1),
                          _hoisted_64,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('current_channel')), 1)
                        ])
                      ])
                    ]),
                    _hoisted_65
                  ]),
                  _createVNode("div", _hoisted_67, [
                    _createVNode("div", _hoisted_68, [
                      _createVNode("div", _hoisted_69, [
                        _createVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('add_as_many')) + " ", 1),
                          _hoisted_70,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('channels_to')) + " ", 1),
                          _hoisted_71,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('your_project')), 1)
                        ])
                      ])
                    ]),
                    _hoisted_72
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_74, [
              _createVNode("div", _hoisted_75, [
                _createVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('create_new_channel_for')) + " ", 1),
                  _hoisted_76,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('different_groups')) + ".", 1)
                ]),
                _hoisted_77
              ]),
              _createVNode("div", _hoisted_78, [
                _hoisted_79,
                _createVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('send_messages_attach_templates_and')) + " ", 1),
                  _hoisted_80,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('custom_files_from_your_computer')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_81, [
                _createVNode("div", _hoisted_82, [
                  _createVNode("div", _hoisted_83, [
                    _hoisted_84,
                    _createVNode("p", null, _toDisplayString(_ctx.$t('invite_a_new_member')), 1)
                  ]),
                  _hoisted_85,
                  _createVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('by_adding')) + " ", 1),
                      _hoisted_88,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('existing_member')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_89, [
                    _createVNode("p", _hoisted_90, _toDisplayString(_ctx.$t('or')), 1)
                  ]),
                  _createVNode("div", _hoisted_91, [
                    _hoisted_92,
                    _createVNode("p", null, _toDisplayString(_ctx.$t('by_email')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_93, [
              _createVNode("div", _hoisted_94, [
                _createVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('access_your_recent_five_chat')) + " ", 1),
                  _hoisted_95,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('channels_in_the_dashboard_itself')) + ".", 1)
                ]),
                _hoisted_96,
                _hoisted_97
              ])
            ])
          ]),
          _createVNode("div", _hoisted_98, [
            _createVNode("div", _hoisted_99, [
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToStep1 && _ctx.redirectToStep1(...args)))
              }, [
                _hoisted_100
              ])
            ]),
            _createVNode("div", _hoisted_101, [
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToStep3 && _ctx.redirectToStep3(...args)))
              }, [
                _hoisted_102
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_103, [
      _createVNode("section", _hoisted_104, [
        _createVNode("div", _hoisted_105, [
          _createVNode("div", _hoisted_106, [
            _createVNode("div", _hoisted_107, [
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/comment.png`: 'timg/comment.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('building_confidence_trust')) + " – ", 1),
                _createVNode("span", _hoisted_108, _toDisplayString(_ctx.$t('one_convo_at_a_time')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_109, [
              _hoisted_110,
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convorally-text.png`: 'timg/convorally-text.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _hoisted_111
            ])
          ])
        ])
      ])
    ])
  ]))
}